import { useDms } from './useDms';

export function useRatingProviders() {
  const { ratingNameMap } = useDms();

  return { ratingProviders: ratingNameMap };
}
